import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import Actions_Wind from '~/Actions_Wind';
import permission from '~/skills/permission';
import PageTitle from '~/components/PageTitle';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_Select, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import Sub1 from './Sub1';

const isOther = text => {
  let res = false;
  try {
    if (JSON.parse(text || '[]').indexOf('其他(請自行新增)') > -1)res = true;
  } catch {}
  return res;
};

class Page_Finance extends Component {
  state={ data: {}, old_data: {}, mode: '', errorAry: [], canSend: true }

  componentDidMount () {
    const { getBaseData } = this.props;
    getBaseData();
  }

  componentDidUpdate (preProps) {
    const { AFincData: preAFincData = {} } = preProps;
    const { AFincData = {} } = this.props;
    if (Object.keys(preAFincData).length === 0 && Object.keys(AFincData).length > 0) {
      this.setState({ data: AFincData, old_data: JSON.parse(JSON.stringify(AFincData)) });
    }
  }

  componentWillUnmount () {
    this.props.clearKey('AFincData');
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  getSendBody=() => {
    const { data } = this.state;
    const body = {
      financing_status: data.financing_status || '',
      financing_date: data.financing_date || '',
      sub1: data.sub1 || [],
      financing_total_price: data.financing_total_price || '',
      merge_windfield_status: data.merge_windfield_status || '',
      merge_windfield_name: data.merge_windfield_name || '',
      financing_domestic_price: data.financing_domestic_price || '',
      financing_domestic_insurance: data.financing_domestic_insurance || '[]',
      financing_domestic_bank: data.financing_domestic_bank || '[]',
      financing_price: data.financing_price || '',
      financing_bank: data.financing_bank || '[]',
      financing_bank_other: data.financing_bank_other || '',
      financing_credit: data.financing_credit || '[]',
      financing_credit_other: data.financing_credit_other || '',
      financing_note: data.financing_note || '',

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const { postAddNewAFincData } = this.props;
    const body = { ...this.getSendBody(), ...status };
    postAddNewAFincData(body);
  }

  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { putAFincData } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putAFincData(this.state.data.id, body);
  }

  _onClose=() => {
    const { clearKey, getAFincData } = this.props;
    clearKey('AFincData');
    getAFincData();
    this.setState({ canSend: true, mode: '' });
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const arytext_Have = text => {
      let res = false;
      try {
        if (JSON.parse(text || '[]').length > 0)res = true;
      } catch {}
      return res;
    };
    const errorAry = [
      returnInputValue(data.financing_status) === '', // 0 國內金融機構融資到位進度 - 選項
      data.financing_status === '已完成' && returnInputValue(data.financing_date) === '', // 1 國內金融機構融資到位進度 - 日期
      returnInputValue(data.financing_total_price) === '', // 2 總融資金額
      returnInputValue(data.merge_windfield_status) === '', // 3 與其他風場合併融資 - 是,否
      data.merge_windfield_status === '1' && returnInputValue(data.merge_windfield_name) === '', // 4 與其他風場合併融資 - 其它
      returnInputValue(data.financing_domestic_price) === '', // 5 國內金額
      !arytext_Have(data.financing_domestic_insurance), // 6 國內保險機構
      !arytext_Have(data.financing_domestic_bank), // 7 國內銀行
      returnInputValue(data.financing_price) === '', // 8 國外金額
      !arytext_Have(data.financing_bank), // 9 國外金融機構-銀行-選項
      isOther(data.financing_bank) && returnInputValue(data.financing_bank_other) === '', // 10 國外金融機構-銀行-新增其他
      !arytext_Have(data.financing_credit), // 11 國外金融機構-信貸-選項
      isOther(data.financing_credit) && returnInputValue(data.financing_credit_other) === '', // 12 國外金融機構-信貸-新增其他
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { AFincBankList = [], AFincCreditList = [], AFincDomBankList = [], AFincDomInsList = [], AFincStatusList = [], canEdit } = this.props;
    const { data, old_data, mode, errorAry, canSend } = this.state;
    const isCheck = mode === 'check';
    const disabled = isCheck || !canEdit || (!getStatus.canEdit(data));
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const allRight = errorAry.indexOf(true) === -1;

    const titleWidth = 155;
    const errorLeft = 20 + titleWidth;
    const isAdd = Object.keys(old_data).length === 0;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='金融項目' />
        <div style={{ height: 8 }} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='國內金融機構' subtitle='融資到位進度' subtitleColor='black' bol haveChange={checkChange('financing_status') || checkChange('financing_date')} />
              <EAA_Select displayBorder disabled={disabled} list={AFincStatusList} value={returnInputValue(data.financing_status)} onChange={data => { this.changeData({ label: 'financing_status', data }); }} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇進度' />}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              { data.financing_status === '已完成' && <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.financing_date)} onChange={data => { this.changeData({ label: 'financing_date', data: getTime.getType3Time(data) }); }} />}
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={0} text='請選擇日期' />}
          </EAA_Item>
        </EAA_Row>

        <Sub1 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='總融資金額' bol haveChange={checkChange('financing_total_price')} />
              <EAA_Input hint='價格' displayBorder type='number' disabled={disabled} label='新台幣' unit='元' value={returnInputValue(data.financing_total_price)} onChange={data => { this.changeData({ label: 'financing_total_price', data }); }} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入金額' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='與其他風場合併融資' bol haveChange={checkChange('merge_windfield_status') || checkChange('merge_windfield_name')} />
              <CircleCheckBox disabled={disabled} value={data.merge_windfield_status === '0'} onClick={() => this.changeData({ label: 'merge_windfield_status', data: '0' })} />
              <div style={{ marginLeft: 4, marginRight: 8 }}>否</div>
              <CircleCheckBox disabled={disabled} value={data.merge_windfield_status === '1'} onClick={() => this.changeData({ label: 'merge_windfield_status', data: '1' })} />
              <div style={{ marginLeft: 4 }}>是，風場為：</div>
              <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.merge_windfield_name)} onChange={data => { this.changeData({ label: 'merge_windfield_name', data }); }} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請勾選' />}
            {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入風場' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='融資-國內金額' bol haveChange={checkChange('financing_domestic_price')} />
              <EAA_Input displayBorder type='number' disabled={disabled} label='新台幣' unit='元' value={returnInputValue(data.financing_domestic_price)} onChange={data => { this.changeData({ label: 'financing_domestic_price', data }); }} />
            </EAA_ItemContainer>
            {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入金額' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='融資-國內保險機構' bol haveChange={checkChange('financing_domestic_insurance')} />
              <EAA_Select displayBorder disabled={disabled} multiple list={AFincDomInsList} hint='請選擇保險機構清單，多選' value={JSON.parse(data.financing_domestic_insurance || '[]')} onChange={data => { this.changeData({ label: 'financing_domestic_insurance', data: JSON.stringify(data) }); }} />
            </EAA_ItemContainer>
            {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='融資-國內銀行' bol haveChange={checkChange('financing_domestic_bank')} />
              <EAA_Select displayBorder disabled={disabled} multiple list={AFincDomBankList} hint='請選擇銀行清單，多選' value={JSON.parse(data.financing_domestic_bank || '[]')} onChange={data => { this.changeData({ label: 'financing_domestic_bank', data: JSON.stringify(data) }); }} />
            </EAA_ItemContainer>
            {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='融資-國外金額' bol haveChange={checkChange('financing_price')} />
              <EAA_Input displayBorder type='number' disabled={disabled} label='新台幣' unit='元' value={returnInputValue(data.financing_price)} onChange={data => { this.changeData({ label: 'financing_price', data }); }} />
            </EAA_ItemContainer>
            {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入金額' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='融資-國外金融機構' bol haveChange={checkChange('financing_bank') || checkChange('financing_bank_other') || checkChange('financing_credit') || checkChange('financing_credit_other')} />
              <EAA_Select displayBorder disabled={disabled} multiple list={AFincBankList} hint='請選擇銀行清單，多選' value={JSON.parse(data.financing_bank || '[]')} onChange={data => { this.changeData({ label: 'financing_bank', data: JSON.stringify(data) }); }} />
            </EAA_ItemContainer>
            {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          {isOther(data.financing_bank) && (
            <EAA_Item>
              <EAA_Input displayBorder disabled={disabled} hint='新增銀行名稱' value={returnInputValue(data.financing_bank_other)} onChange={data => { this.changeData({ label: 'financing_bank_other', data }); }} />
              {errorAry[10] && <EAA_ErrorText marginLeft={0} text='請輸入' />}
            </EAA_Item>
          )}
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} />
              <EAA_Select displayBorder disabled={disabled} multiple list={AFincCreditList} hint='請選擇信貸清單，多選' value={JSON.parse(data.financing_credit || '[]')} onChange={data => { this.changeData({ label: 'financing_credit', data: JSON.stringify(data) }); }} />
            </EAA_ItemContainer>
            {errorAry[11] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          {isOther(data.financing_credit) && (
            <EAA_Item>
              <EAA_Input displayBorder disabled={disabled} hint='新增信貸名稱' value={returnInputValue(data.financing_credit_other)} onChange={data => { this.changeData({ label: 'financing_credit_other', data }); }} />
              {errorAry[12] && <EAA_ErrorText marginLeft={0} text='請輸入' />}
            </EAA_Item>
          )}
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='備註' haveChange={checkChange('financing_note')} />
              <EAA_Memo displayBorder disabled={disabled} value={returnInputValue(data.financing_note)} onChange={data => { this.changeData({ label: 'financing_note', data }); }} />
            </EAA_ItemContainer>
            {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
        </EAA_Row>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          disGoBack
          {...{
            data,
            mode: canEdit ? (isAdd ? 'add' : 'edit') : 'view',
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />

        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewAFincData' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutAFincData' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  AFincBankList: state.data.AFincBankList,
  AFincCreditList: state.data.AFincCreditList,
  AFincDomBankList: state.data.AFincDomBankList,
  AFincDomInsList: state.data.AFincDomInsList,
  AFincStatusList: state.data.AFincStatusList,
  AFincData: state.data.AFincData,
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions_Wind.clearKey(dispatch, { key }),
  getBaseData: () => {
    Actions_Wind.getAFincBankList(dispatch);
    Actions_Wind.getAFincCreditList(dispatch);
    Actions_Wind.getAFincDomBankList(dispatch);
    Actions_Wind.getAFincDomInsList(dispatch);
    Actions_Wind.getAFincStatusList(dispatch);
    Actions_Wind.getAFincData(dispatch);
  },
  getAFincData: () => Actions_Wind.getAFincData(dispatch),
  postAddNewAFincData: body => Actions_Wind.postAddNewAFincData(dispatch, { body }),
  putAFincData: (id, body) => Actions_Wind.putAFincData(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_Finance);
